import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

const FLAGS = [
  { key: "selfbilling_enabled", title: "Fatture provvigioni automatiche", text: "Master e dealer vedono la scheda Fatture provvigioni, firmano l'autorizzazione e a fine mese la fattura viene creata in automatico.", on: "Fatture provvigioni attive", off: "Fatture provvigioni nascoste e create solo a mano" },
  { key: "invoices_to_receive_enabled", title: "Fatture da ricevere", text: "Master e dealer vedono le fatture dei servizi in arrivo nella pagina Fatture.", on: "Fatture da ricevere visibili", off: "Fatture da ricevere nascoste" },
  { key: "referral_page_enabled", title: "Pagina Invita & Guadagna", text: "Se attiva, dealer, master e clienti vedono in Il mio account la pagina con il link di invito e i guadagni.", on: "Invita & Guadagna visibile", off: "Invita & Guadagna nascosta a tutti" },
];

export const InvoiceFeatureFlags = () => {
  const [v, setV] = useState(null);
  useEffect(() => { api.get("/settings/features").then(({ data }) => setV(data)).catch(() => {}); }, []);
  const toggle = async (f, x) => {
    setV((s) => ({ ...s, [f.key]: x }));
    try { await api.put("/settings/features", { [f.key]: x }); toast.success(x ? f.on : f.off); }
    catch { setV((s) => ({ ...s, [f.key]: !x })); toast.error("Errore salvataggio"); }
  };
  if (!v) return null;
  return <div className="space-y-4" data-testid="invoice-feature-flags">
    {FLAGS.map((f) => <div key={f.key} className="flex items-center justify-between gap-3">
      <div><h2 className="font-head text-lg font-semibold">{f.title}</h2><p className="text-xs text-muted-foreground mt-0.5">{f.text}</p></div>
      <Switch checked={!!v[f.key]} onCheckedChange={(x) => toggle(f, x)} data-testid={`flag-${f.key}`} />
    </div>)}
  </div>;
};
